/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _extends = require('babel-runtime/helpers/extends')['default'];

exports.__esModule = true;
exports['default'] = reducer;
exports.isLoaded = isLoaded;
exports.load = load;
var LOAD = 'baltimorebrew.com/page/LOAD';
var LOAD_SUCCESS = 'baltimorebrew.com/page/LOAD_SUCCESS';
var LOAD_FAIL = 'baltimorebrew.com/page/LOAD_FAIL';

var initialState = {
	loaded: false,
	data: {}
};

function reducer() {
	var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	switch (action.type) {
		case LOAD:
			{
				return _extends({}, state, {
					loading: true
				});
			}
		case LOAD_SUCCESS:
			{
				return _extends({}, state, {
					loading: false,
					loaded: true,
					data: action.result,
					error: null
				});
			}
		case LOAD_FAIL:
			{
				return _extends({}, state, {
					loading: false,
					loaded: false,
					data: null,
					error: action.error
				});
			}
		default:
			{
				return state;
			}
	}
}

function isLoaded(globalState) {
	return globalState.page && globalState.page.loaded && globalState.router.params.id === String(globalState.page.data.id);
}

function load(page) {
	return {
		types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
		promise: function promise(client) {
			return client.get('/bbrew/v1/page?name=' + page);
		}
	};
}
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/page.js
 ** module id = 266
 ** module chunks = 0
 **/